import React from 'react';
import { Table as BsTable } from 'react-bootstrap';
import { Container } from './styles';

interface ITableProps {
    bordered?: boolean;
    borderBottom?: string;
}

export const Table: React.FC<ITableProps> = ({
    children,
    bordered,
    borderBottom
}) => {

    return (
        <Container bordered={bordered} borderBottom={borderBottom}>
            <BsTable>
                {children}
            </BsTable>
        </Container>
    );
}